import { ExpressionType } from 'app/model/expressions/expression';
import { DataFlowDataType } from 'worker/app-workers/shared/models/dataflow-datatype';

export type DynamicDataType = 'String' | 'Boolean' | 'DateTime' | 'Float' | 'Int' | 'Object' | 'Array' | 'FileFormat' | 'Compression' |
    'ManagementIdentityInfo' | 'FilePath' | 'ConnectionString' | 'AzureResource' | 'SchemaTable' | 'Table';

export type UIControlType = BasicControlType | AdvancedControlType;

export type BasicControlType = 'TextBox' | 'TextArea' | 'TextBoxNumber' | 'CheckBox' | 'RadioButton' | 'DropDown' | 'MultiSelect' | 'DateTimePicker';

export type AdvancedControlType = 'ObjectContainer' | 'ArrayContainer' | 'FileLocation' | 'SchemaTableSelection' | 'TableSelection' | 'QueryTextArea'
    | 'FileFormat' | 'Compression' | 'ManagementIdentityInfo' | 'ConnectionStringContainer' | 'AzureResourceSelection';

export const advancedControlTypes = ['FileFormat', 'Compression', 'ManagementIdentityInfo', 'FilePath', 'ConnectionString', 'AzureResource'];

// these controls should not be rendered on UI with dynamic mechanism, as they've already been handled statically
export const staticTabularConnectorControlTypes = ['SchemaTableSelection', 'TableSelection', 'QueryTextArea'];

// these controls should not be rendered on UI with dynamic mechanism, as they've already been handled statically
export const staticFileTypeConnectorControlTypes = ['FileLocation'];

export function mapDatatypeToExpressionType(dynamicDataType: DynamicDataType): ExpressionType[] {
    if (dynamicDataType != null) {
        switch (dynamicDataType) {
            case 'String':
            case 'DateTime':
                return ['String'];
            case 'Int':
                return ['Int'];
            case 'Float':
                return ['Float'];
            case 'Boolean':
                return ['Bool'];
            case 'Object':
                return ['Object'];
            case 'Array':
                return ['Array'];
            default:
                return ['Any'];
        }
    }
    return [];
}

export function mapBackendDatatypeToDynamicType(backendDataType: string): DynamicDataType {
    switch (backendDataType) {
        case 'string':
        case 'String':
        case 'Guid':
        case 'TimeSpan':
            return 'String';
        case 'dateTime':
        case 'DateTimeOffset':
        case 'DateTime':
            return 'DateTime';
        case 'integer':
        case 'Int16':
        case 'Int32':
        case 'Int64':
            return 'Int';
        case 'float':
        case 'double':
        case 'Double':
            return 'Float';
        case 'boolean':
        case 'Boolean':
            return 'Boolean';
        case 'object':
            return 'Object';
        case 'array':
            return 'Array';
        default:
            return 'String';
    }
}

export function mapDatatypeToDataflowType(dynamicDataType: DynamicDataType): DataFlowDataType {
    switch (dynamicDataType) {
        case 'Array':
            return 'array';
        case 'AzureResource':
            return 'any';
        case 'Boolean':
            return 'boolean';
        case 'Compression':
            return 'any';
        case 'ConnectionString':
            return 'any';
        case 'DateTime':
            return 'datetime';
        case 'FileFormat':
            return 'any';
        case 'FilePath':
            return 'any';
        case 'Float':
            return 'float';
        case 'Int':
            return 'integer';
        case 'ManagementIdentityInfo':
            return 'any';
        case 'Object':
            return 'any';
        case 'SchemaTable':
            return 'any';
        case 'String':
            return 'string';
        case 'Table':
            return 'any';
        default:
            return 'any';
    }
}
